import { RouteView } from "@/layouts";
export default {
  path: "/serve",
  name: "serve",
  redirect: "/serve/index",
  component: RouteView,
  meta: {
    title: "诊疗服务",
    icon: "home-o",
    showNavBar: true,
  },
  children: [
    {
      path: "/serve/index",
      name: "serveIndex",
      component: () =>
        import(/* webpackChunkName: "serve" */ "@/views/serve/Index.vue"),
      meta: {
        title: "诊疗服务",
        showNavBar: true,
      },
    },
    {
      path: "/serve/pre-order",
      name: "servePreOrder",
      component: RouteView,
      redirect: "/serve/pre-order/department",
      meta: {
        title: "预约挂号",
        showNavBar: false,
      },
      children: [
        {
          path: "/serve/pre-order/department",
          name: "servePreOrderDepartment",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/Department.vue"),
          meta: {
            title: "选择科室",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/selectDoctorList",
          name: "servePreOrderSelectDoctorList",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/SelectDoctorList.vue"),
          meta: {
            title: "选择医生",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/doctor-list",
          name: "servePreOrderDoctorList",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/DoctorList.vue"),
          meta: {
            title: "选择医生",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/doctor-info",
          name: "servePreOrderDoctorInfo",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/DoctorInfo.vue"),
          meta: {
            title: "选择时间",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/confirm",
          name: "servePreOrderConfirm",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/Confirm.vue"),
          meta: {
            title: "确认预约",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/pay",
          // path: "/api/WeChatPay/Pay",
          name: "servePreOrderPay",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/Pay.vue"),
          meta: {
            title: "确认支付",
            showNavBar: false,
          },
        },
        {
          path: "/serve/pre-order/result",
          name: "servePreOrderResult",
          component: () =>
            import(/* webpackChunkName: "serve" */ "@/views/serve/preOrder/Result.vue"),
          meta: {
            title: "预约挂号结果",
            showNavBar: false,
          },
        },
      ],
    },
    {
      path: "/serve/lineup",
      name: "serveLineup",
      component: () =>
        import(/* webpackChunkName: "serve" */ "@/views/serve/lineup/List.vue"),
      meta: {
        title: "排队候诊",
        showNavBar: false,
      },
    },
    {
      path: "/serve/lineup/info",
      name: "serveLineupInfo",
      component: () =>
        import(/* webpackChunkName: "serve" */ "@/views/serve/lineup/Info.vue"),
      meta: {
        title: "排队候诊",
        showNavBar: false,
      },
    },
  ],
};
